module.exports = __webpack_public_path__ + "static/media/beyond.36044bca.jpg";